import React, { useState } from 'react'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'

const useLoginStyles = makeStyles(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  formInput: {
    marginRight: 12,
  },
  formContent: {
    display: 'flex',
    padding: '50px',
  },
  formError: {
    display: 'flex',
    color: brandColors.error,
    marginTop: 12,
  },
}))

export function Login({ onLogin }: { onLogin: (password: string) => boolean }) {
  const classes = useLoginStyles()
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const password = e.currentTarget.password.value
    const res = onLogin(password)
    if (!res) {
      setError('Incorrect password, please try again.')
    }
  }

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <div className={classes.formContent}>
        <input
          type='password'
          name='password'
          placeholder='Password'
          className={classes.formInput}
        />
        <button type='submit'>Login</button>
      </div>
      {error && <div className={classes.formError}>{error}</div>}
    </form>
  )
}
